var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 29.5312C48.75 26.9531 46.6406 24.8438 44.0625 24.8438H39.375V7.03125C39.375 4.44246 37.2763 2.34375 34.6875 2.34375H25.3125C22.7237 2.34375 20.625 4.44246 20.625 7.03125V24.8438H15.9375C13.3594 24.8438 11.25 26.9531 11.25 29.5312C11.25 30.8439 11.7655 32.0157 12.6093 32.8595L26.6718 46.922C27.5155 47.7657 28.6874 48.2812 30 48.2812C31.3126 48.2812 32.4845 47.7657 33.3282 46.922L47.3907 32.8595C48.2345 32.0157 48.75 30.8439 48.75 29.5312Z",
    stroke: "white",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4375 48.2812V52.9688C53.4375 55.5575 51.3388 57.6562 48.75 57.6562H11.25C8.66121 57.6562 6.5625 55.5575 6.5625 52.9688V48.2812",
    stroke: "white",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.e1306936144963c8e3001d22fb672e5f.svg";
export { ForwardRef as ReactComponent };